import React from "react";

export default class StepFeedback extends React.Component {

    render() {
        return <span className={"step_feedback " + (this.props.className||"")}>
            {this.props.children}
        </span>
    }
}